module.exports = __webpack_public_path__ + "static/media/python.ca2ceddc.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/cardicons/python.png
// module id = 1502
// module chunks = 0